<template>
  <v-card
    elevation="3"
    rounded="lg"
  >
    <v-toolbar
      flat
      dense
      color="color_green"
      dark
    >
      <v-toolbar-title class="text-subtitle-2">
        Top Callers
      </v-toolbar-title>
      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        dense
        dark
        class="shrink"
        style="max-width: 220px"
      />
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      :items-per-page="15"
      dense
      @click:row="onRowClick"
    >
      <template #item.total_calls="{ item }">
        <span class="font-weight-bold color_green--text">
          {{ item.total_calls.toLocaleString('it-IT') }}
        </span>
      </template>

      <template #item.username="{ item }">
        <v-btn
          text
          x-small
          color="primary"
          @click.stop="$emit('drill-down', item)"
        >
          {{ item.username }}
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'TopCallersTable',
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Username', value: 'username' },
        { text: 'Email', value: 'email' },
        { text: 'Customer', value: 'customer_id' },
        { text: 'Total Calls', value: 'total_calls', align: 'end' }
      ]
    };
  },
  methods: {
    onRowClick(item) {
      this.$emit('drill-down', item);
    }
  }
};
</script>
